import React from 'react'
import { CSSTransition } from 'react-transition-group'
import ArtistInfo from '../ArtistInfo/ArtistInfo'
import { FloorInfo } from '../FloorInfo/FloorInfo'
import {
  changeFilter as change,
  ChangeFilterPayload,
  closeFilter as close,
  // resetFilter as reset,
  getFilters,
  openFilter as open,
} from '../state/filter/filterSlice'
import { useAppDispatch, useAppSelector } from '../state/hooks'
import './FilterSelects.css'
import SearchInput from './SearchInput'

const FilterSelects = () => {
  const filters = useAppSelector(getFilters)
  const dispatch = useAppDispatch()

  const closeFilter = () => dispatch(close())
  // const resetFilter = (id: string) => dispatch(reset(id))
  const openFilter = (id: string) => dispatch(open(id))
  const changeFilter = (payload: ChangeFilterPayload) =>
    dispatch(change(payload))

  return (
    <React.Fragment>
      <CSSTransition
        in={filters.openedFilter === 'search'}
        timeout={300}
        classNames="search"
        mountOnEnter
        // unmountOnExit
      >
        {(state) => {
          return (
            <div className="search">
              <SearchInput
                show={state !== 'exited'}
                value={filters.search}
                onClose={closeFilter}
                onChange={(value) => {
                  changeFilter({ filterId: 'search', value })
                }}
              />
            </div>
          )
        }}
      </CSSTransition>

      <CSSTransition
        in={filters.openedFilter === 'info'}
        timeout={300}
        classNames="info"
        mountOnEnter
        // unmountOnExit
      >
        {
          (/*state: any*/) => {
            return (
              <div className="info">
                <ArtistInfo id={filters.info} key={filters.info} />
              </div>
            )
          }
        }
      </CSSTransition>

      <CSSTransition
        in={filters.openedFilter === 'floorInfo'}
        timeout={300}
        classNames="floorInfo"
        mountOnEnter
        // unmountOnExit
      >
        {(state) => {
          // console.log('floorInfo state: ', state)
          if (state === 'exited') {
            return null
          }

          return (
            <div className="floorInfo">
              <FloorInfo
                floor={filters.floorInfo}
                onClose={() => openFilter('floors')}
              />
            </div>
          )
        }}
      </CSSTransition>
    </React.Fragment>
  )
}
export default FilterSelects
